<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>字典列表</h4>
        </div>
        <!-- 查询条件 -->
        <div class="inpBox">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="组名：">
              <el-select v-model="formInline.type" size="mini" placeholder="请选择组名">
                <el-option
                v-for="(item,index) in type2"
                :label="item.showName"
                :key="index"
                :value="item.showName2"
              ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun" btnCode='000P00MB001' v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongZhi()" btnCode='000P00MB002' v-if="btnFlg[1]" >重置</el-button>
              <el-button type="primary" size="mini" @click="addBtn" btnCode='000P00MB003' v-if="btnFlg[2]">新增</el-button>
              <el-button type="primary" size="mini" @click="xiugaiBtn" btnCode='000P00MB004' v-if="btnFlg[3]">修改</el-button>
              <el-button type="primary" size="mini" @click="deleteBtn" btnCode='000P00MB005' v-if="btnFlg[4]">删除</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--表格-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table
          border
          height="100%"
          size="mini"
          ref="tabref"
          :data="cangchuTableData"
          style="width:100%"
          class="elTab"
          highlight-current-row
          @row-click="dianjixuanzhong"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="groupNo"
            label="编码"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="ext1"
            label="组名"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="itemNo"
            label="编号"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="showName"
            label="显示名称"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="orderBy"
            label="显示顺序"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="
            备注"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="createName"
            label="创建人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="200"
            :formatter="dateFormat"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="updateName"
            label="修改人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            width="200"
            align="center"
            :formatter="dateFormat"
          >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.updateTime == null"></span>
            <span v-if="scope.row.updateTime != null">{{scope.row.updateTime | dateFormat}}</span>
          </div></template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页 style="text-align: right;"-->
      <div class="pags" >
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!--点击添加按钮弹出框-->
    <div class="addMarkBox">
      <el-dialog
        title="添加字典"
        :visible.sync="addMark"
        :close-on-click-modal="false"
        @close="reset('addFormData')"
        :validate-on-rule-change = "false"
        width="40%"
        center
      >
        <!--form表单-->
        <el-form
          :model="addFormData"
          ref="addFormData"
          label-width="100px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item
            label="组名"
            prop="kehuName"
            :rules="[
                { required: true, message: '组名不能为空', trigger: 'blur' },
              ]"
          >
            <el-select
              style="width:200px"
              size="mini"
              filterable
              v-model="addFormData.kehuName"
              placeholder="请选择组名"
              :validate-event = "false"
            >
              <el-option
                v-for="(item,index) in type"
                :label="item.showName"
                :key="index"
                :value="item.showName2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="编号:"
            prop="numAdd"
            :rules="[
                { required: true, message: '编号不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-number-input.float="0"
              v-model="addFormData.numAdd"
              style="width:200px"
              size="mini"
              placeholder="请输入编号"
              maxlength="5"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="显示名称:"
            prop="name"
            :rules="[
                { required: true, message: '显示名称不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-model="addFormData.name"
              style="width:200px"
              size="mini"
              placeholder="请输入显示名称"
              maxlength="50"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="显示顺序:"
            prop="one"
            :rules="[
                { required: true, message: '显示顺序不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-number-input.float="0"
              v-model="addFormData.one"
              style="width:200px"
              size="mini"
              placeholder="请输入显示顺序"
              maxlength="9"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              v-model="addFormData.beizhu"
              style="width:200px"
              size="mini"
              placeholder="请输入备注"
              maxlength="200"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="addQueding('addFormData')" :loading="addLoad">确定</el-button>
          <el-button type="primary" @click="addQuXiao('addFormData')">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击修改按钮弹出框-->
    <div class="addMarkBox">
      <el-dialog
        title="修改字典"
        :visible.sync="xiugaiMark"
        :close-on-click-modal="false"
        :validate-on-rule-change = "false"
        width="40%"
        center
      >
        <!--form表单-->
        <el-form
          :model="xiugaiFormData"
          ref="xiugaiFormData"
          label-width="100px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item
            label="组名"
            prop="kehuName"
            :rules="[
                { required: true, message: '组名不能为空', trigger: 'blur' },
              ]"
          >
            <el-select
              style="width:200px"
              size="mini"
              filterable
              v-model="xiugaiFormData.kehuName"
              placeholder="请选择组名"
              :validate-event = "false"
              :disabled="bianHaoDisabled"
            >
              <el-option
                v-for="(item,index) in type"
                :label="item.showName"
                :key="index"
                :value="item.showName2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="编号:"
            prop="numAdd"
            :rules="[
                { required: true, message: '编号不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-number-input.float="0"
              v-model="xiugaiFormData.numAdd"
              style="width:200px"
              size="mini"
              placeholder="请输入编号"
              maxlength="5"
              :disabled="bianHaoDisabled"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="显示名称:"
            prop="name"
            :rules="[
                { required: true, message: '显示名称不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-model="xiugaiFormData.name"
              style="width:200px"
              size="mini"
              placeholder="请输入显示名称"
              maxlength="50"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="显示顺序:"
            prop="one"
            :rules="[
                { required: true, message: '显示顺序不能为空', trigger: 'blur' },
              ]"
          >
            <el-input
              v-number-input.float="0"
              v-model="xiugaiFormData.one"
              style="width:200px"
              size="mini"
              placeholder="请输入显示顺序"
              maxlength="9"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              v-model="xiugaiFormData.beizhu"
              style="width:200px"
              size="mini"
              placeholder="请输入备注"
              maxlength="200"
              :validate-event = "false"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="width:158px;margin:15px auto;">
          <el-button
            type="primary"
            @click="xiugaiQueding('xiugaiFormData')"
            :loading="xiugaiLoad"
          >确定</el-button>
          <el-button type="primary" @click="xiugaiQuXiao('xiugaiFormData')">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getBtn } from '@/utils/getButton'

import { 
  getGroupNos,
  insertDictionary ,
  getDictionaryForUpdate,
  updateDictionary,
  deleteDictionary
} from "@/api/wms-stock"
import { 
  dictionarySearch, // 列表数据
  dictionarySelect, // 组名下拉框
  dictionaryAdd,    // 新增
  dictionaryChange, //修改
  dictionaryDelete,  // 删除
} from "@/api/platform-settlement"
import DonMessage from '@/utils/message'

export default {
  name: 'RukuDan',
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ["000P00MB001","000P00MB002","000P00MB003","000P00MB004","000P00MB005"],
      h: '500px',
      numAdd: 0,
      cangchuTableData: [],
      type: [],
      xuanzhongArr: [],
      //  添加-客户
      addFormData: {
        kehuName: '', //  组名
        numAdd: '', //  编号
        name: '', //  名称
        one: '', //  顺序
        beizhu: '' //  备注
      },
      //  添加-客户
      xiugaiFormData: {
        kehuName: '', //  组名
        numAdd: '', //  编号
        name: '', //  名称
        one: '', //  顺序
        beizhu: '' //  备注
      },
      kehuAddName: '',
      kehuAddnumAdd: '',
      type2:[],
      addMark: false,
      xiugaiMark: false,
      addLoad: false,
      xiugaiLoad: false,
      //  查询条件
      formInline: {
        kehuName: '',
        ruKuStartTime: '',
        ruKuEndTime: '',
        chuanhao: ''
      },
      pagesize: 20,
      current: 1,
      total: 0,
      bianHaoDisabled:false,
    };
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight //  头部搜索盒子高度
    let pH = document.documentElement.clientHeight //  浏览器高度
    this.h = pH - h - 100 + 'px'
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/smpDic/dataList')

    this.getDictionaryListS()
    this.getGroupNosS() // 获取客户
    this.getGroupNosS2()
  },
  methods: {
    reset (formName) {
      var _this = this
      _this.$refs[formName].resetFields()
    },
    //  点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.numAdd = 0
    },
    //  字典-查询客户
    getGroupNosS () {
      dictionarySelect({
        type:0
      })
        .then(res => {
          this.type = res
        })
        .catch(err => {
          DonMessage.error(err.message);
        })
    },
    //  字典-查询客户    ---查询条件的组名
    getGroupNosS2 () {
      dictionarySelect({
      })
        .then(res => {
          this.type2 = res
        })
        .catch(err => {
          DonMessage.error(err.message);
        })
    },
    //  主数据
    getDictionaryListS () {
      dictionarySearch({
        pageNo: this.current, //  页数
        pageSize: this.pagesize, //  条数
        groupNo: this.formInline.type, // 组名
        groupType:0
      })
        .then(res => {
          this.xuanzhongArr = []
          this.total = res.total
          this.cangchuTableData = res.list
        })
        .catch(err => {
          DonMessage.error(err.message);
        })
    },

    // 点击添加按钮
    addBtn () {
      this.addMark = true
      this.addFormData = {
        kehuName: "",
        numAdd: "",
        name: "",
        one: "",
        beizhu: ""
      }
      this.getGroupNosS() // 获取客户
    },
    // 点击修改按钮
    xiugaiBtn( ) {

      if (this.xuanzhongArr.length==0) {
          DonMessage.error("请选择要操作的信息")
      }else{
        this.xiugaiMark = true
        this.bianHaoDisabled = true
        this.xiugaiFormData.kehuName = this.xuanzhongArr.groupNo
        this.xiugaiFormData.numAdd = this.xuanzhongArr.itemNo
        this.xiugaiFormData.name = this.xuanzhongArr.showName
        this.xiugaiFormData.one = this.xuanzhongArr.orderBy
        this.xiugaiFormData.beizhu = this.xuanzhongArr.remark
        //  getDictionaryForUpdate({
        //     dictionaryId:this.xuanzhongArr.dictionaryId,//  字典表id
        //     })
        //       .then(res => {
        //         this.xiugaiMark = true
        //         
        //       })
        //       .catch(err => {
        //         DonMessage.error(err.message);
        //       })
      }
      //  this.getGroupNosS(); // 获取客户
    },
    // 添加-确定
    addQueding (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addMark = false
          dictionaryAdd({
            id:'',
            groupNo:this.addFormData.kehuName,//  组名
            itemNo:this.addFormData.numAdd,//  编号
            showName:this.addFormData.name,//  显示名称
            showName2:'',
            updateFlg:1,
            orderBy:this.addFormData.one,//  显示顺序
            remark:this.addFormData.beizhu,//  备注
          })
            .then(res => {
              DonMessage.success("操作成功!")
              this.addLoad = false
              this.getDictionaryListS()
            })
            .catch(err => {
              DonMessage.error(err.message);
              this.addLoad = false
            })
        } else {
          // DonMessage.error("")
          //  this.$refs["from"].clearValidate() //  移除校验结果
          return false
        }
      })
    },
    //  点击添加弹出框取消按钮
    addQuXiao (formName) {
      this.$refs[formName].resetFields()
      //  this.addFormData={
      //    kehuName: "",
      //    chuanhao: "",
      //  },
      this.addMark = false
    },
    //  修改----
    xiugaiQueding (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.xiugaiMark = false
          this.addLoad = true
           dictionaryChange({
              updateFlg:1,
              id:this.xuanzhongArr.id,//  字典表id
              itemNo:this.xiugaiFormData.numAdd,//  编号
              showName:this.xiugaiFormData.name,//  显示名称
              orderBy:this.xiugaiFormData.one,//  显示顺序
              remark:this.xiugaiFormData.beizhu,//  备注
              groupNo:this.xiugaiFormData.kehuName,//  组名
           })
             .then(res => {
               DonMessage.success("操作成功!")
               this.addLoad = false
               this.getDictionaryListS()
             })
             .catch(err => {
               DonMessage.error(err.message);
               this.addLoad = false
             })
        } else {
          DonMessage.error("请维护完整信息再操作")
          //  this.$refs["from"].clearValidate() //  移除校验结果
          return false
        }
      });
    },
    xiugaiQuXiao(formName) {
      this.$refs[formName].resetFields()
      //  this.addFormData={
      //    kehuName: "",
      //    chuanhao: "",
      //  },
      this.xiugaiMark = false
    },
    //  点击删除
    deleteBtn() {
      if (this.xuanzhongArr.length == 0) {
        DonMessage.error("请选择需要操作的信息")
      } else {
          this.$confirm("是否确定删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              dictionaryDelete({
                id:this.xuanzhongArr.id, //  字典表id
              })
                .then(res => {
                  DonMessage.success("操作成功!")
                  this.getDictionaryListS()
                })
                .catch(err => {
                  DonMessage.error(err.message);
                })
            })
            .catch(() => {})
      }
    },

    //  查询
    chaxun () {
      this.getDictionaryListS()
    },
    // 重置
    chongZhi () {
      this.formInline = {
        kehuName: '',
        ruKuStartTime: '',
        ruKuEndTime: '',
        chuanhao: ''
      }
      this.getDictionaryListS()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getDictionaryListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getDictionaryListS()
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
  
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.el-form-item {
  margin-left: 10px;
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    //  margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    // text-align: center;
  }
  //  border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      //  margin-top: 5px;
      width: 100%;

      //  border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
</style>
